<template lang="pug">
  #appFooter.appFooter.appFooter-sm
</template>

<script>
export default {
  name: 'appSmFooter'
};
</script>

<style>

</style>
